import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import type { DrawerViewProps } from '@app/src/components/Drawer/DrawerView'
import DrawerView from '@app/src/components/Drawer/DrawerView'
import Markdown from '@app/src/components/Markdown'
import type { Question } from '@app/src/types/resourceExplorer'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type DrawerViewAccessorQuestionGuidanceProps = {
  question: Question
} & Omit<DrawerViewProps, 'title' | 'subtitle'>

const DrawerViewAccessorQuestionGuidance: React.FC<DrawerViewAccessorQuestionGuidanceProps> = ({
  question,
  ...props
}) => {
  const { closeDrawer } = useDrawer()
  const { formatMessage } = useIntl()
  const { kpiName, questionText, guidance, accessorGuidance } = question

  return (
    <DrawerView
      title={formatMessage({ id: 'schemas.question.guidance' })}
      buttons={[
        {
          label: formatMessage({ id: 'general.close' }),
          variant: 'text',
          onClick: closeDrawer,
        },
      ]}
      {...props}
    >
      <Box px={3}>
        {accessorGuidance && (
          <Box mb={2}>
            <Box bgcolor="communication.light" borderRadius={2} p={3}>
              <Typography variant="subtitle1" gutterBottom>
                {formatMessage({ id: 'baselineAssessment.accessorQuestionDrawer.accessorGuidanceHeader' })}
              </Typography>
              <Typography variant="body1">
                <Markdown>{accessorGuidance}</Markdown>
              </Typography>
            </Box>
          </Box>
        )}
        {kpiName && (
          <Box>
            <Typography variant="subtitle1" gutterBottom>
              {formatMessage({ id: 'baselineAssessment.accessorQuestionDrawer.kpiNameHeader' })}
            </Typography>
            <Typography variant="body1" paragraph>
              {kpiName}
            </Typography>
          </Box>
        )}
        <Box>
          <Typography variant="subtitle1" gutterBottom>
            {formatMessage({ id: 'general.question' })}
          </Typography>
          <Typography variant="body1" paragraph>
            {questionText}
          </Typography>
        </Box>
        {guidance && (
          <Box>
            <Typography variant="subtitle1" gutterBottom>
              {formatMessage({ id: 'baselineAssessment.accessorQuestionDrawer.providerGuidanceHeader' })}
            </Typography>
            <Typography variant="body1" paragraph>
              <Markdown>{guidance}</Markdown>
            </Typography>
          </Box>
        )}
      </Box>
    </DrawerView>
  )
}

export default DrawerViewAccessorQuestionGuidance
